import React, { useEffect, createElement } from 'react';
import { FreeTrialCTABand } from './free-trial/FreeTrialCTABand';
import { FreeTrialHeroInfo } from './free-trial/FreeTrialHeroInfo';
import { FreeTrialHeroForm } from './free-trial/FreeTrialHeroForm';
import { FreeTrialPrograms } from './free-trial/FreeTrialPrograms';
import { FreeTrialAudiences } from './free-trial/FreeTrialAudiences';
import { FreeTrialExpectations } from './free-trial/FreeTrialExpectations';
import { FreeTrialReviews } from './free-trial/FreeTrialReviews';
import { FreeTrialSchedule } from './free-trial/FreeTrialSchedule';
import { FreeTrialLocation } from './free-trial/FreeTrialLocation';
import { FreeTrialFAQHeader } from './free-trial/FreeTrialFAQHeader';
import { FreeTrialFAQQuestions } from './free-trial/FreeTrialFAQQuestions';
import { FreeTrialRelatedLinks } from './free-trial/FreeTrialRelatedLinks';
export function FreeTrial() {
  useEffect(() => {
    document.title = 'Start a Trial Class at Storm Taekwondo | Farmington Hills, MI';
    const desc = 'Find the right Storm Taekwondo class or program. Kids, adults, family, self-defense, competition team and summer camp options in Farmington Hills. Check availability today.';
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = desc;
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-1593">
      <section className="relative bg-ink pt-12 pb-20 lg:pt-20 lg:pb-28 overflow-hidden" data-id="element-1594">
        <div className="absolute top-0 right-0 w-1/3 h-full bg-storm-red transform skew-x-12 translate-x-32 opacity-10 pointer-events-none" data-id="element-1595" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1596">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start" data-id="element-1597">
            <FreeTrialHeroInfo data-id="element-1598" />

            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto lg:sticky lg:top-24" data-id="element-1599">
              <FreeTrialHeroForm data-id="element-1600" />
            </div>
          </div>
        </div>
      </section>
      <FreeTrialPrograms data-id="element-1601" />
      <FreeTrialAudiences data-id="element-1602" />
      <FreeTrialExpectations data-id="element-1603" />
      <FreeTrialReviews data-id="element-1604" />
      <FreeTrialSchedule data-id="element-1605" />
      <FreeTrialLocation data-id="element-1606" />
      <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-1607">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1608">
          <FreeTrialFAQHeader data-id="element-1609" />
          <FreeTrialFAQQuestions data-id="element-1610" />
        </div>
      </section>
      <FreeTrialRelatedLinks data-id="element-1611" />
      <FreeTrialCTABand data-id="element-1612" />
    </div>;
}